export const supplant = (str, config = {}) => str.replace(/{{(.*?)}}/g, (match, key) => {
    const r = config[key] || {};
    return typeof r === 'string' || typeof r === 'number' ? r : match;
});

export const createVocab = (
    {
        minChars = __('news_vj_search_lookup_min_chars'),
        noResults = __('news_vj_search_lookup_no_results'),
        oneResultAvailable = __('news_vj_search_lookup_one_result_available'),
        multipleResultsAvailable = __('news_vj_search_lookup_multiple_results_available'),
        selectedResult = __('news_vj_search_lookup_selected_result')
    },
) => {
    return {
        minChars: num => supplant(minChars, { num: num }),
        noResults: noResults,
        oneResultAvailable: suggestion => supplant(oneResultAvailable, { suggestion: suggestion }),
        multipleResultsAvailable: numberOfResults => supplant(multipleResultsAvailable, {
            numberOfResults: numberOfResults,
        }),
        selectedResult: suggestion => supplant(selectedResult, { suggestion: suggestion }),
    };
};

export default createVocab;
